import { Actions } from '@components/shared/Actions'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { ProfileItemProps } from '../context/types'
import { getProfileType } from './getProfileType'
import { ProfileStatus } from '../components/ProfileStatus'
import { ProfileStatusEnum } from '../components/ProfileStatus/types'
import { EyeIcon, TrashSimpleIcon } from '@phosphor-icons/react'

interface ParseAccessProfileGridProps {
  data: ProfileItemProps[]
  onSeeMore: (data: ProfileItemProps) => void
  onRemove: (data: ProfileItemProps) => void
}

export const parseAccessProfileGrid = ({ data, onSeeMore, onRemove }: ParseAccessProfileGridProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'id',
      columnName: 'ID',
      value: item.id || '-',
      align: 'center',
      sortable: true,
      minWidth: '3rem',
      maxWidth: '3rem'
    },
    {
      id: 'name',
      columnName: 'Descrição do Perfil',
      value: item.name || '-',
      sortable: true,
      minWidth: '10rem'
    },
    {
      id: 'type',
      columnName: 'Tipo de Perfil',
      align: 'center',
      value: item.type ? getProfileType(item.type) : '-',
      sortable: true,
      minWidth: '14rem'
    },
    {
      id: 'status',
      columnName: 'Status',
      align: 'center',
      value: <ProfileStatus status={item.isActive ? ProfileStatusEnum.ACTIVE : ProfileStatusEnum.INACTIVE} />,
      sortable: true,
      minWidth: '7rem',
      withoutTooltip: true
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: (
        <Actions
          actions={[
            { label: 'Ver mais', icon: <EyeIcon size={24} weight="bold" />, onClick: () => onSeeMore(item) },
            { label: 'Excluir', icon: <TrashSimpleIcon size={24} />, onClick: () => onRemove(item) }
          ]}
        />
      )
    }
  ])

  return parsedData
}
